import { render } from "./TemplateDiffView.vue?vue&type=template&id=e60d7480&scoped=true"
import script from "./TemplateDiffView.vue?vue&type=script&lang=js"
export * from "./TemplateDiffView.vue?vue&type=script&lang=js"

import "./TemplateDiffView.vue?vue&type=style&index=0&id=e60d7480&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e60d7480"]])

export default __exports__